import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import moment from "moment/moment";
import {Channel} from "../../../../domain/channel";
import {UserService} from "../../../../domain/user-service";
import {ChannelRepository} from "../../../../domain/channel-repository";
import {HttpStatusCode} from "@angular/common/http";
import {UI} from "../../../../services/ui.service";

@Component({
  selector: 'evrideo-download-recording',
  templateUrl: './download-recording.component.html',
  styleUrl: './download-recording.component.scss'
})
export class DownloadRecordingComponent implements OnInit {




  @Input()
  channel: Channel;

  @Input()
  showTimeFilters: boolean = false;

  @Output()
  closeButtonClicked = new EventEmitter();

  allChannelAvailabilityZone: {id:number, displayName: string}[] = [];
  dateFilterTime: moment.Moment;
  fromTimeMinutes: number = 0;
  toTimeMinutes: number = 60;
  selectedAvailabilityZoneId: number;
  closeIcon = "/assets/icons/x-close-pop.svg";
  responseMessage = '';

  constructor(
    private _userService: UserService,
    private _channelRepository: ChannelRepository,
    private _ui: UI,

  ) {
  }

  ngOnInit(): void {
    const allActiveAvailabilityZones =  this._userService.getCurrentUser().channelAvailabilityZones;
    this.allChannelAvailabilityZone = allActiveAvailabilityZones.filter(x => this.channel._availabilityZoneIds.includes(x.id));
    this.reset();
  }

  onCloseButtonClicked(event) {
    event.stopImmediatePropagation();
    this.closeButtonClicked.emit();
  }

  public reset() {
    this.responseMessage = '';

    if (this.allChannelAvailabilityZone.length > 0) {
      this.selectedAvailabilityZoneId = this.allChannelAvailabilityZone[0].id;
    }

    this.dateFilterTime = moment.utc().subtract(2, 'days');

    this.fromTimeMinutes = 0;
    this.toTimeMinutes = ((60*24) - 1);
  }


  protected async onDownloadClicked($event: MouseEvent) {
    //First need to generate the token

    const fromTime = this.dateFilterTime.clone().startOf('day').add(this.fromTimeMinutes, 'minutes');
    const toTime = this.dateFilterTime.clone().startOf('day').add(this.toTimeMinutes, 'minutes');
    try {
      const downloadRecordingToken = await this._channelRepository.generateDownloadChannelRecordingToken(this.channel.id,this.selectedAvailabilityZoneId, fromTime, toTime);

      if (this.fromTimeMinutes > 0) {
        this._ui.notify(this._ui.EVENTS.ShowAlert, {
          title: "Preparing your recording for download.",
          message: "The recording is being preprocessed, download will start in up to 15 minutes. Please do not close this window until that time."
        });
      }
      const statusCode = await this._channelRepository.downloadChannelRecording(downloadRecordingToken, this.selectedAvailabilityZoneId, fromTime, toTime );
      //this.reset();

      this.closeButtonClicked.emit();
    }catch (e) {
      console.error(`DownloadRecordingComponent->onDownloadClicked`,e);
      if (e.status === HttpStatusCode.NotFound) {
        this.responseMessage = "No recording found!"
      } else {
        this.responseMessage = "Unexpected error occurred. Please try again later!";
      }
    }
  }
}
